var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiringRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 31.172,
    viewBox: "0 0 38 31.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vote_1598533",
    transform: "translate(0 -46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39791",
    "data-name": "Path 39791",
    d: "M152.109,121a1.109,1.109,0,1,0,1.109,1.109A1.11,1.11,0,0,0,152.109,121Z",
    transform: "translate(-139.79 -69.432)",
    fill: "#fc7336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39792",
    "data-name": "Path 39792",
    d: "M124.328,211A3.331,3.331,0,0,0,121,214.328v1.109h6.655v-1.109A3.331,3.331,0,0,0,124.328,211Z",
    transform: "translate(-112.013 -152.746)",
    fill: "#fc7336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39793",
    "data-name": "Path 39793",
    d: "M38,376H23.914l-2.227,2.218H16.312L14.086,376H0a7.966,7.966,0,0,0,7.867,6.655H30.133A7.966,7.966,0,0,0,38,376Z",
    transform: "translate(0 -305.483)",
    fill: "#fc7336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39794",
    "data-name": "Path 39794",
    d: "M30,68.185H42.787L45.015,70.4h3.533l2.228-2.218H63.563V46H30Zm29.034-3.328H47.9V62.638H59.034Zm0-4.437H47.9V58.2H59.034ZM56.806,49.328h2.228v2.218H56.806Zm0,4.437h2.228v2.218H56.806Zm-9.237-1.893,1.44,1.434,3.668-3.653,1.575,1.569-5.243,5.221-3.015-3ZM34.53,61.529A5.564,5.564,0,0,1,40.1,55.983a3.328,3.328,0,1,1,3.341-3.328A3.338,3.338,0,0,1,40.1,55.983a5.564,5.564,0,0,1,5.569,5.546v3.328H34.53Z",
    transform: "translate(-27.493 0)",
    fill: "#fc7336"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiringRequestIcon);
export default __webpack_public_path__ + "static/media/hiring_request_icon.c9febe32cbbc7178b3e111423e7a161c.svg";
export { ForwardRef as ReactComponent };